import React, {useEffect, useState} from "react";
import PropTypes from 'prop-types';
import Autocomplete from "@material-ui/lab/Autocomplete/Autocomplete";
import {TextField} from "@material-ui/core";
import makeStyles from "@material-ui/styles/makeStyles";
import Input from "@material-ui/core/Input";
import FieldWrapper from "../../FieldWrapper";
import findByString from "../../Utils/getValueByString";
import {checkHidden} from "../../Utils/checkHidden";
import {errorHandler} from "../../Utils/errorHandler";
import {checkEvents} from "../../Utils/checkEvents";
import DialogWrapper from "./DialogWrapper";
import PopoverWrapper from "./PopoverWrapper";
import VsCodeEditor from "./VsCodeEditor";
import {setArrayPath} from "../../Utils/setArrayPath";
import FieldErrorMessage from "../../Utils/errorMessage";

const useStyles = makeStyles(() => ({
    valueInputRoot: {
        paddingRight: 0,
    },
    inputRoot: {
        '&[class*="MuiOutlinedInput-root"]': {
            padding: 1,
            // '& $input': {
            //     padding: '2px 4px !important',
            // },
        },
    },
    option: {
        minHeight: 2,
        display: 'flex',
        justifyContent: 'flex-start',
        alignItems: 'center',
        cursor: 'pointer',
        paddingTop: 1,
        boxSizing: 'border-box',
        outline: '0',
        WebkitTapHighlightColor: 'transparent',
        paddingBottom: 2,
        paddingLeft: 16,
        paddingRight: 16,
    },
    paper: {
        width: 'auto',
        '& > ul': {
            maxHeight: 200,
            overflow: 'auto',
        },
    },
    clearIndicator: {
        display: 'none',
    },
    tag: {
        height: '24px'
    },
}));
const ScriptType = (props) => {
    const {
        field, setValue, values, errors, goBack, focusNow, events, containerArrayPath,
        fieldStyles, labelStyles, showLabel, isMobile, globalValues, screenName
    } = props;
    const {path: sourcePath, label, required, disabled, autofocus, type, syntaxHighlight, inputMode, entitySuggestion} = field;
    const path = containerArrayPath ? setArrayPath(sourcePath, containerArrayPath) : sourcePath;
    const classes = useStyles();
    const [isOpen, setIsOpen] = useState(null);
    const [fieldEvents, setFieldEvents] = useState({onBlur: null, onChange: null});
    const [inputValue, setInputValue] = useState('{}');
    const [inPopup, setInPopup] = useState(null);
    const [error, setError] = useState('');
    const findValue = findByString(values, path);
    const mode = syntaxHighlight ? modeTranslations[syntaxHighlight].mode : 'javascript';

    useEffect(() => {
        setInputValue(findValue || '');
        const currentEvents = checkEvents(events);
        setFieldEvents(currentEvents)
    }, []);

    useEffect(() => {
        if (typeof findValue === 'object') {
            setInputValue(JSON.stringify(findValue));
            return
        }
        setInputValue(findValue || '')

    }, [findValue]);

    useEffect(() => {
        let errorField = errorHandler(errors, path, containerArrayPath);
        setError(errorField)
    }, [errors]);

    function onKeyDown(e) {
        if (e.key === 'Enter') {
            e.stopPropagation();
            e.preventDefault();
            setIsOpen(e.currentTarget)
        }
        if (e.key === 'F2') {
            e.stopPropagation();
            e.preventDefault();
            setIsOpen(e.currentTarget)
        }
    }

    const onChangeInput = (e) => {
        openEditChip(e);
        setInputValue(e.target.value)
    };
    const onChangeScriptEditor = (value) => {
        setInputValue(value)
    };
    const onBlurInput = (value) => {
        onSaveScript(value)
    };
    const openEditChip = (e) => {
        e.stopPropagation();
        setIsOpen(e.currentTarget)
    };
    const closeEditScript = () => {
        setIsOpen(null);
    };
    const onSaveScript = (value) => {
        setInputValue(value);
        setValue(value, path);
        closeEditScript();
    };

    /* popup functions */
    function togglePopup(e) {
        setInPopup(prev => {
            return !prev ? e.currentTarget : null
        })
    }


    const isHidden = checkHidden(globalValues, field.hideCondition);
    const isDisabled = checkHidden(globalValues, disabled);
    const fieldPresentation = fieldStyles.presentation ?
        fieldStyles.presentation === 'inlineWithLabel' ? 'standard' :
            fieldStyles.presentation === 'stackLabel' ? 'outlined' :
                fieldStyles.presentation : 'outlined'
    return (
        <FieldWrapper
            isHidden={isHidden}
            setValue={setValue}
            path={path}
            label={label}
            fieldStyles={fieldStyles}
            labelStyles={{...labelStyles, alignSelf: 'flex-start'}}
            showLabel={showLabel}
            record={values}
            goBack={goBack}
            globalValues={globalValues}
            screenName={screenName}
        >
            {inputMode === 'inline' ? (
                <>
                    <Autocomplete
                        freeSolo
                        open={false}
                        disabled={isDisabled}
                        classes={{
                            inputRoot: classes.inputRoot,
                            clearIndicator: classes.clearIndicator,
                            option: classes.option,
                            paper: classes.paper,
                            tag: classes.tag,
                        }}
                        options={[]}
                        //onBlur={onBlurInput}
                        value={inputValue || ''}
                        inputValue={inputValue || ''}
                        onClick={openEditChip}
                        closeIcon={<></>}
                        renderInput={params => (
                            <>
                                <Input {...params} type={'hidden'} style={{display: 'none'}}/>
                                <VsCodeEditor
                                    onKeyDown={() => {
                                    }}
                                    onChange={onChangeScriptEditor}
                                    currentValue={inputValue}
                                    onBlur={onBlurInput}
                                    autoFocus={autofocus}
                                    style={{
                                        height: fieldStyles.height
                                    }}
                                    mode={mode}
                                    openInPopup={togglePopup}
                                    entitySuggestion={entitySuggestion}
                                />
                            </>
                        )}
                    />
                    <ScriptInput
                        type={type}
                        open={inPopup}
                        onClose={togglePopup}
                        value={inputValue}
                        inputValue={inputValue}
                        setValue={onSaveScript}
                        syntaxHighlight={syntaxHighlight}
                        mode={mode}
                        entitySuggestion={entitySuggestion}
                    />
                </>
            ) : (
                <>
                    <Autocomplete
                        freeSolo
                        open={false}
                        disabled={isDisabled}
                        classes={{
                            inputRoot: classes.inputRoot,
                            clearIndicator: classes.clearIndicator,
                            option: classes.option,
                            paper: classes.paper,
                            tag: classes.tag,
                        }}
                        options={[]}
                        value={inputValue || ''}
                        inputValue={inputValue || ''}
                        onClick={openEditChip}
                        closeIcon={<></>}
                        className={"sb-entity-external-field"}
                        renderInput={params => (
                            <TextField
                                {...params}
                                multiline
                                rows={5}
                                required={required && !inputValue.length}
                                fullWidth={isMobile ? true : fieldStyles.fullWidth}
                                error={error.length > 0}
                                autoFocus={autofocus || focusNow}
                                className={fieldStyles.withoutStyles ? 'horizontal-fields-table' : 'form-dynamic'}
                                disabled={isDisabled}
                                onChange={(e) => onChangeInput(e)}
                                onClick={!isDisabled && openEditChip}
                                label={isMobile || fieldStyles.presentation === 'standard' && label}
                                variant={isMobile ? 'standard' : fieldPresentation}
                                onKeyDown={onKeyDown}
                                value={''}
                                inputProps={{
                                    ...params.inputProps,
                                    style: {
                                        height: fieldStyles.height
                                    },
                                    className: !fieldStyles.withoutStyles && 'with-styles',
                                }}
                                style={{
                                    width: '100%',
                                    margin: fieldStyles.margin,
                                    paddingLeft: 2,
                                    paddingTop: 3
                                }}
                            />
                        )}
                    />
                    <ScriptInput
                        type={type}
                        open={isOpen}
                        onClose={closeEditScript}
                        value={inputValue}
                        inputValue={inputValue}
                        setValue={onSaveScript}
                        syntaxHighlight={syntaxHighlight}
                        mode={mode}
                        entitySuggestion={entitySuggestion}
                    />

                </>
            )}
            <FieldErrorMessage message={error}/>
        </FieldWrapper>
    )
};
export default ScriptType

ScriptType.propTypes = {
    field: PropTypes.shape({
        path: PropTypes.string,
        label: PropTypes.string,
        required: PropTypes.bool,
        disabled: PropTypes.bool,
        autofocus: PropTypes.bool,
        hideCondition: PropTypes.string,
        inputMode: PropTypes.oneOf(['inline', 'popup']),
        syntaxHighlight: PropTypes.oneOf(['mongodb', 'javascript', 'json', 'sql']),
    }),
    errors: PropTypes.array,
    fieldStyles: PropTypes.object,
    labelStyles: PropTypes.object,
    setValue: PropTypes.func,
    showLabel: PropTypes.bool,
    values: PropTypes.any,
    focusNow: PropTypes.bool,
    onBlurFromCell: PropTypes.bool,
    goBack: PropTypes.func
};

ScriptType.defaultProps = {
    goBack: () => {
    },
    setValue: () => {
    },
    values: {},
    labelStyles: {},
    fieldStyles: {},
    errors: [],
};

const modeTranslations = {
    sql: {mode: 'mysql', title: "Sql Query"},
    json: {mode: 'json', title: "JSON"},
    javascript: {mode: 'javascript', title: "Script"},
    mongodb: {mode: 'mongodb', title: "Mongo Query"},
    css: {mode: 'css', title: "CSS"}
};

const ScriptInput = ({open, onClose, value, inputValue, setValue, type, syntaxHighlight, mode, entitySuggestion}) => {
    const [currentValue, setCurrentValue] = useState('');
    const [fullScreen, setFullScreen] = useState(false);
    const onChange = (value) => {
        setCurrentValue(value)
    };
    const onKeyDown = (e) => {
        if (e.ctrlKey && e.key === 's') {
            e.stopPropagation();
            e.preventDefault();
            setValue(currentValue)
        }
    };
    const apply = () => {
        setValue(currentValue)
    };
    const toggleFullScreen = () => {
        setFullScreen(prev => !prev)
    };
    const title = syntaxHighlight ? modeTranslations[syntaxHighlight].title :
        type === 'script' ? "Script" : "JSON";
    useEffect(() => {
        if (inputValue && inputValue.length) {
            setCurrentValue(inputValue);
            return
        }
        if (open && value) {
            setCurrentValue(value ? value : inputValue)
        }
    }, [open]);

    return (
        fullScreen ? (
            <DialogWrapper
                open={open}
                onClose={onClose}
                toggleFullScreen={toggleFullScreen}
                title={title}
                apply={apply}
            >
                <VsCodeEditor
                    onChange={onChange}
                    currentValue={currentValue}
                    autoFocus={true}
                    fullScreen={fullScreen}
                    mode={mode}
                    onKeyDown={onKeyDown}
                    hideOpenInPopup
                    entitySuggestion={entitySuggestion}
                />
            </DialogWrapper>
        ) : (
            <PopoverWrapper
                open={open}
                onClose={onClose}
                apply={apply}
                toggleFullScreen={toggleFullScreen}
                title={title}
            >
                <VsCodeEditor
                    onChange={onChange}
                    autoFocus={true}
                    currentValue={currentValue}
                    fullScreen={fullScreen}
                    mode={mode}
                    onKeyDown={onKeyDown}
                    hideOpenInPopup
                    style={{height: '100%', width: '100%'}}
                    entitySuggestion={entitySuggestion}
                />
            </PopoverWrapper>
        )
    )
};